import React, {useContext, useEffect, useState} from 'react';
import {Button, Col, ConfigProvider, Form, Input, Modal, Row, Select} from 'antd';
import Colors from "../../../styles/Colors";
import { BiCheck, BiX } from "react-icons/bi";
import {GetInscripcionsActivitatIdTorn} from "../../../dao/inscripcions/GetInscripcionsInscripcioIdTorn";
import {PostInscripcionsContacte} from "../../../dao/inscripcions/PostInscripcionsContacte";
import {useParams} from "react-router-dom";
import {AuthContext} from "../../../config/AuthContext";
import locale from "antd/es/locale/es_ES";

interface PagadorModalProps {
    element: any; // Cambiado a tipo any para aceptar cualquier tipo de elemento
    visible: boolean;
    onClose: (value: boolean) => void;
}

const PagadorModal: React.FC<PagadorModalProps> = ({ element, visible, onClose }) => {
    const [form] = Form.useForm();
    const [efectiu, setEfectiu] = useState(true);

    const {isLoggedIn, userId, user, page, userDni, userCognom} = useContext(AuthContext);
    const {id_inscripcio} = useParams();

    const [idInsc, setIdInsc] = useState(0);

    useEffect(() => {
        setEfectiu(element.metalic);
        setIdInsc(id_inscripcio !== undefined ? id_inscripcio : element.id_inscripcio);
    }, []);

    async function handleSubmit () {
        let formData = form.getFieldsValue();
        if (formData.iba1) {
            formData.iba1 = formData.iba1.replace(/\s+/g, '').toUpperCase();
        }
        formData = {...formData, pagador: 1};
        //console.log("Form Data:", formData);
        //console.log(JSON.stringify(formData));
        await PostInscripcionsContacte(idInsc+"", page, formData);
        onClose(true);
    };

    const handleCancel = () => {
        onClose(false);
    };

    function changePagament() {
        setEfectiu(!efectiu);
    }


    const IBAN_REGEX = /^[A-Z]{2}[0-9]{22}$/i;

    return (
        <ConfigProvider locale={locale}>
        <Modal
            title="PAGADOR"
            visible={visible}
            onCancel={handleCancel}
            footer={[]}
            width={window.innerWidth < 768 ? "100%" : "70%"}
        >
            <Form form={form} initialValues={element} onFinish={handleSubmit}>
                <Row gutter={[16, 16]}>
                    <Col span={efectiu ? 12 : 8}>
                        <Form.Item label="ID" name="id">
                            <Input disabled />
                        </Form.Item>
                        <Form.Item label="Nom" name="nom"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="Cognoms" name="cognoms"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="Telèfon" name="telefon"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="Telèfon 2" name="telefon2">
                            <Input />
                        </Form.Item>
                        <Form.Item label="Telèfon 3" name="telefon3">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={efectiu ? 12 : 8}>
                        <Form.Item label="DNI" name="dni"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="Email" name="email"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="% Quota" name="quota"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="number" />
                        </Form.Item>
                        <Form.Item label="Metàl·lic" name="metalic"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select
                                placeholder="Selecciona modalitat pagament"
                                options={[
                                    {label:"Efectiu", value:true},
                                    {label:"Compte bancari", value:false}
                                ]}
                                onChange={() => changePagament()}
                            />
                        </Form.Item>
                        <Form.Item label="Parentesc" name="parentesc"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="Direcció" name="direccio"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input />
                        </Form.Item>
                    </Col>
                    {!efectiu && (
                        <Col span={8}>
                            <Form.Item label="IBAN" name="iba1"
                                       rules={[
                                           {
                                               required: !efectiu,
                                               message: 'Aquest camp es obligatori',
                                           },
                                           ({ getFieldValue }) => ({
                                               validator(_, value) {
                                                   if (!value || IBAN_REGEX.test(value.replace(/\s+/g, ''))) {
                                                       return Promise.resolve();
                                                   }
                                                   return Promise.reject(new Error('IBAN no és vàlid'));
                                               },
                                           }),
                                       ]}>
                                <Input />
                            </Form.Item>
                        </Col>
                    )}
                </Row>
                <Form.Item wrapperCol={{offset: 0, span: 16}}>
                    <Button title={"Acceptar"} htmlType={"submit"} style={{backgroundColor: Colors.colors.color6}}
                    ><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </Form.Item>
            </Form>
        </Modal>
        </ConfigProvider>
    );
};

export default PagadorModal;
